// extracted by mini-css-extract-plugin
export default {"root":"ClassCreationTrackerModal_root__qQFAH"};